import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=771f247f&scoped=true&"
import script from "./DetailsDialog.vue?vue&type=script&lang=js&"
export * from "./DetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=771f247f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f247f",
  null
  
)

export default component.exports